import { Component, inject, OnInit } from '@angular/core';
import { LdwRouterService } from '../../route/ldw-router.service';
import { DocumentHelper } from '../../shared/helpers/document-helper';
import { MatDialog } from '@angular/material/dialog';
import { DocumentService } from '../../shared/services/document.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { InfoService } from '../../shared/services/info.service';
import { DocumentDetail } from '../../shared/models/document-detail';
import { WebDokuNodeValue } from '../../shared/models/web-doku-node-value';
import { SettingsService } from '../../shared/settings/settings.service';
import { tap } from 'rxjs';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'ldw-document-info-page',
  templateUrl: './document-info-page.component.html',
  styleUrls: ['./document-info-page.component.css'],
  standalone: false
})
export class DocumentInfoPageComponent implements OnInit {
  private routerService = inject(LdwRouterService);
  private documentService = inject(DocumentService);
  private infoService = inject(InfoService);
  private route = inject(ActivatedRoute);
  private settingsService = inject(SettingsService);

  document: DocumentDetail | undefined = undefined;
  documentHelper: DocumentHelper;

  private dialog = inject(MatDialog);
  private translate = inject(TranslateService);
  protected title = inject(Title);

  constructor() {
    this.documentHelper = new DocumentHelper(this.dialog, this.routerService, this.translate);
    this.infoService.clearStatus();
  }

  ngOnInit(): void {
    const docid = this.route.snapshot.paramMap.get('docid');
    if (docid == undefined) {
      this.documentHelper.documentNotFound(undefined);
      return;
    }

    this.documentService.getDocument(docid)
      .pipe(
        tap(document => this.title.setTitle(document.text)),
      )
      .subscribe(
        {
          next: (value) => {
            this.document = value;

            console.log(this.document);
          },
          error: (error) => this.error(docid, error)
        }
      );
  }

  error(docid: string, error: any) {
    this.documentHelper.documentNotFound(docid);
    console.log(error);
  }

  get list(): WebDokuNodeValue[] {
    if (
      this.document == undefined ||
      this.document.additionalInfos == undefined
    ) {
      return [];
    }
    return this.document.additionalInfos;
  }

  close() {
    this.routerService.navigateBack();
  }

  showToolTip(): boolean {
    return this.settingsService.settings.viewMode.showTooltips;
  }
}
